import { render, staticRenderFns } from "./StatistiqueAnomaliesTable.vue?vue&type=template&id=52b1ac6c"
import script from "./StatistiqueAnomaliesTable.vue?vue&type=script&lang=js"
export * from "./StatistiqueAnomaliesTable.vue?vue&type=script&lang=js"
import style0 from "./StatistiqueAnomaliesTable.vue?vue&type=style&index=0&id=52b1ac6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports